<template id="bs-modal-physician">
<div class="modal fade" id="physicianCreateModal" tabindex="-1" role="dialog" ref="physicianCreateModal">
<div class="modal-dialog" role="document">
<div class="modal-content">
	<div class="text-gray-500 font-weight-bold text-uppercase text-base bg-gray-100 px-3 py-25 rounded-top border-bottom">
		<span v-if="!new_physician">Create Physician</span>
		<span v-else>New Physician Saved</span>
		<button type="button" class="close" data-dismiss="modal" aria-label="Close">
        	<span aria-hidden="true">&times;</span>
        </button>
	</div>

	<div v-if="!new_physician" class="d-flex text-sm py-2 border-bottom mb-2">
		<div class="d-flex flex-fill justify-content-center align-items-center" style="line-height:18px;">
			<div v-if="form_step === 1" class="rounded-circle circle-cropped avatar-custom text-center text-white mr-1 bg-primary">1</div>

			<div v-else class="rounded-circle circle-cropped avatar-custom text-center text-white mr-1 bg-gray-600"><i class="far fa-check"></i></div>
			<span :class="form_step === 1 ? 'text-gray-700' : 'text-gray-500'">Source</span>
		</div>

		<div class="d-flex flex-fill justify-content-center align-items-center" style="line-height:18px;">
			<div v-if="form_step === 2" class="rounded-circle circle-cropped avatar-custom text-center text-white mr-1 bg-primary">2</div>

			<template v-else>
				<div v-if="form_step === 1" class="rounded-circle circle-cropped avatar-custom text-center text-white mr-1 bg-gray-400">2</div>

				<div v-if="form_step === 3" class="rounded-circle circle-cropped avatar-custom text-center text-white mr-1 bg-gray-600"><i class="far fa-check"></i></div>
			</template>

			<span :class="form_step === 2 ? 'text-gray-700' : 'text-gray-500'">Profile</span>
		</div>

		<div class="d-flex flex-fill justify-content-center align-items-center" style="line-height:18px;">
			<template v-if="form_step === 3">
				<div v-if="form.address && form.city && form.state" class="rounded-circle circle-cropped avatar-custom text-center text-white mr-1 bg-primary"><i class="far fa-check"></i></div>
				<div v-else class="rounded-circle circle-cropped avatar-custom text-center text-white mr-1 bg-gray-700">3</div>
			</template>
			<div v-else class="rounded-circle circle-cropped avatar-custom text-center text-white mr-1 bg-gray-400">3</div>

			<span :class="form_step === 3 ? 'text-gray-700' : 'text-gray-500'">Location</span>
			
		</div>
	</div>

	<img v-if="submitting" class="center-me" style="z-index:10" src="/images/loading-color.svg">

	<div v-if="!new_physician" class="modal-body py-0 px-3" :class="{ 'faded' : submitting }">		
		<form @submit.prevent="submitForm" @keydown="form.onKeydown($event)" @change="form.onKeydown($event)" class="mb-0">
			<alert-errors :form="form">There were some problems with your input.</alert-errors>
			<template v-if="form_step === 1">
				<div v-if="!form.source" class="text-gray-700 text-2xl text-center my-4">
					How would you like to add the new physician?
				</div>
				<div v-if="!form.source" class="d-flex text-center justify-content-center align-items-center pb-4 mb-3">
					<div class="flex-fill border-right">
						<div class="mx-auto mb-3" style="max-width:30px">
							<img src="/images/logos/google-g-logo.svg" class="img-fluid" @click="setSource('google')">
						</div>
						<span class="btn btn-light" @click="setSource('google')" data-test="searchGoogle">Search Google</span>
					</div>

					<div class="flex-fill">
						<div class="rounded-circle circle-cropped avatar-md text-white bg-gray-600 text-xl mx-auto mb-3" @click="setSource('manual')">
							<i class="fad fa-typewriter"></i>
						</div>
						<span class="btn btn-light" @click="setSource('manual')" data-test="addManually">Add Manually</span>
					</div>
				</div>
				<div v-if="form.source === 'google'">
					<div class="text-gray-700 text-2xl text-center mt-4 mb-3">
						Search for a physician name or location
					</div>

					<gmap-autocomplete
						:types="['establishment']"
						:componentRestrictions="{ country: 'US' }"
						@submit.prevent="submitForm"
						@input="value = $event.target.value"
						@place_changed="processLocationChanged($event)"
						placeholder="Search here..." class="introInput form-control mb-5 mt-3" />

					<div class="d-flex justify-content-between button-wrap border-top p-3">
						<span class="btn btn-ghost-secondary" @click="setSource(null)"><i class="fal fa-long-arrow-left"></i> Change Source</span>
						<span class="btn btn-primary" :class="{ 'disabled' : !google_result }" @click="useGoogleResult()">Use result</span>
					</div>
				</div>

			</template>

			<template v-if="form_step === 2">
				<div v-if="google_result" class="bg-yellow-100 text-yellow-800 mt-2 mb-3 p-2 rounded text-sm">
					Imported data from Google. Please check for accuracy!
				</div>

				<div class="d-flex mt-2 mb-3 leading-tight">
	               <avatar-field 
	                    ref="image_field"
	                    :default_url="'/images/avatars/default.png'"
	                    button="Drop file or click to browse"
	                    class="mr-3"
	                    @avatar_changed="changedAvatar($event)"
	                />

					<div class="flex-grow-1">
						<div class="form-row">
							<div class="col-4">
								<div class="form-group">
									<label class="mb-0">Prefix <span class="text-gray-500 d-none d-sm-inline"> - Opt.</span></label>
									<input class="form-control" v-model="form.prefix" data-test="newPhysicianPrefix">
								</div>
							</div>					
							<div class="col-8">
								<div class="form-group">
									<label class="mb-0">First Name</label>
									<input class="form-control" v-model="form.first_name" required data-test="newPhysicianFname">
								</div>
							</div>
						</div>

						<div class="form-row">
							<div class="col-8">
								<div class="form-group">
									<label class="mb-0">Last Name</label>
									<input class="form-control" v-model="form.last_name" require data-test="newPhysicianLname">
								</div>
							</div>					
							<div class="col-4">
								<div class="form-group">
									<label class="mb-0">Suffix <span class="text-gray-500 d-none d-sm-inline"> - Opt.</span></label>
									<input class="form-control" v-model="form.suffix" data-test="newPhysicianSuffix">
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="form-row">
					<div class="col">
						<div v-for="(email, index) in form.emails" class="">
                            
                            <label class="mb-0">Email<span v-if="index > 0"> #{{ index+1}}</span>
                            <span v-else> Primary</span>
                            <span class="text-gray-500"> - Opt.</span></label>

                            <div class="w-100 d-flex">                                        
                                <input v-model="email.email" type="email" class="form-control mb-2" data-test="newGroupEmail" :data-lpignore="true" >
                                <span
                                    @click="deleteEmail(email.email)"
                                    v-tooltip.bottom="'Delete Email'"
                                    class="btn btn-sm text-gray-300 cursor-pointer leading-none float-right pt-2"
                                    data-test="deleteEmail" >
                                    <i class="fas fa-times-circle"></i>
                                </span>
                            </div>
                        </div>   

                        <div style="height: 25px;">
                            <span
                                @click="addEmail()"
                                v-tooltip.bottom="'Add Email'"
                                class="btn btn-sm btn-ghost-primary text-gray-500 cursor-pointer leading-none float-right"
                                data-test="addEmailButton" >
                                <i class="far fa-plus-circle text-base" />
                            </span> 
                        </div>

					</div>
					
				</div>

				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label class="mb-0">NPI Num. <span class="text-gray-500"> - Opt.</span></label>
							<input class="form-control" v-model="form.npi"  data-test="newPhysicianNpi">
						</div>
					</div>
				</div>

				<div class="form-row">
					<div class="col">							
						<div class="form-group">
							<label class="mb-0">Specialties <span class="text-gray-500"> - Opt.</span></label>
		                    <v-select		                     	                               
		                        multiple
		                        label="label"                                
		                        :options="options.specialties"
		                        :reduce="label => label.id"
		                        v-model="form.specialty"
		                        data-test="newPhysicianSpecs" 
		                    />
						</div>
					</div>
				</div>
			</template>

			<template v-if="form_step === 3">
				<div class="bg-yellow-100 text-yellow-800 mt-2 mb-3 p-2 rounded text-sm">
					Locations are optional. Records without locations can't be mapped or added to routes.
				</div>

				<div class="form-row">
					<div class="col">				
						<div class="form-group">
							<label class="mb-0">Location Name/Label</label>
							<input class="form-control" v-model="form.label" data-test="locationLabel">
						</div>
					</div>
				</div>

	            <div class="form-row mb-2">
	                <div class="col-8 pr-1">   
	                	<label class="mb-0">Address</label>
	                	<input class="form-control" v-model="form.address" data-test="locationAddress">
	            	</div>
	            	<div class="col-4 pl-1">
	            		<label class="mb-0">&nbsp;</label>
	                    <input class="form-control" v-model="form.address_2" placeholder="Address 2">
	                </div>
	            </div>

				<div class="form-row">
					<div class="col-6">								
						<div class="form-group">
							<label class="mb-0">City</label>
							<input class="form-control" v-model="form.city" data-test="locationCity">
						</div>
					</div>
					<div class="col-3">
						<div class="form-group select-state">
							<label class="mb-0">State</label>
		                    <v-select
		                    	:clearable="false"
		                        label="label"
		                        :select-on-key-codes="[9, 13]"
		                        :options="options.states"
		                        :reduce="label => label.id"
		                        v-model="form.state"
		                        data-test="locationState"
		                    />
						</div>
					</div>
					<div class="col-3">
						<div class="form-group">
							<label class="mb-0">Zip</label>
							<input class="form-control" v-model="form.zip" data-test="locationZip">
						</div>
					</div>
				</div>
				<div class="form-row">
					<div class="col">				
						<div class="form-group">
							<label class="mb-0">Phone</label>
							<input class="form-control" v-model="form.phone">
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label class="mb-0">Fax</label>
							<input class="form-control" v-model="form.fax">
						</div>
					</div>
				</div>
			</template>

			<div v-if="form_step != 1" class="form-row button-wrap border-top text-right">
				<div v-if="form_step === 2" class="d-flex justify-content-between pt-3 pb-3 px-3 w-100">
					<span class="btn btn-ghost-secondary" @click="setFormStep(1)"><i class="fal fa-long-arrow-left"></i> Change Source</span>

					<button :disabled="form.busy || !form.first_name || !form.last_name" class="btn btn-primary" @click.prevent="setFormStep(3)" data-test="nextStepButton">Next Step <i class="fal fa-long-arrow-right"></i></button>
				</div>
				<div v-if="form_step === 3" class="d-flex justify-content-between pt-3 pb-3 px-3 w-100">
					<span class="btn btn-ghost-secondary" @click="setFormStep(2)"><i class="fal fa-long-arrow-left"></i> Profile</span>
					<button type="submit" class="btn btn-primary" data-test="savePhysicianButton">Add Physician</button>
				</div>				
			</div>

		</form>
	</div>

	<template v-else>
		<div class="modal-body py-3 px-3">
			<div class="d-flex justify-content-center my-4">
				<div class="rounded-circle circle-cropped avatar-xl">
					<img :src="new_physician.photo_url" class="img-fluid">
				</div>

				<div class="ml-3">
					<div class="text-2xl text-gray-700 mb-1">
						{{ new_physician.display_name }} 
						<router-link :to="{ name: 'physicians.show', params: { id: new_physician.id } }" class="btn btn-sm btn-light ml-2">View profile <i class="fal fa-long-arrow-right"></i></router-link>
					</div>
					<span
		                v-for="specialty in new_physician.specialties"
		                class="badge text-base bg-teal-200 text-teal-700 mb-1 mr-1"
		                v-html="specialty.label" />
		            <div v-if="new_physician.location_primary" class="my-2">
		            	<span v-html="new_physician.location_primary.formatted_address" />
		            </div>
		            <div v-if="new_physician.location_primary && new_physician.location_primary.phone">{{ new_physician.location_primary.phone }}</div>
		            <div v-if="new_physician.location_primary && new_physician.location_primary.fax">{{ new_physician.location_primary.fax }} <span class="text-gray-600">(fax)</span></div>
				</div>
			</div>

			<div class="d-flex justify-content-center pt-2 pb-4">
				<div v-if="new_physician.location_primary && new_physician.location_primary.address" class="text-center px-25 cursor-pointer" @click="displayAddToRoute(value)"  data-test="addNewPhysicianRoute">
					<div 
						class="rounded-circle circle-cropped avatar-md text-white text-center text-xl mx-auto my-2"
						:class="show_add_to_route ? 'bg-primary' : 'bg-secondary'">
						<i class="fad fa-route"></i>
					</div>
					<span class="btn btn-sm btn-light">Add to route</span>
				</div>
				<div class="text-center px-25 cursor-pointer" @click="displayAddToCampaign(true)" data-test="addNewPhysicianCampaign">
					<div 
						class="rounded-circle circle-cropped avatar-md text-white text-center text-xl mx-auto my-2"
						:class="show_add_to_campaign ? 'bg-primary' : 'bg-secondary'">
						<i class="fad fa-fire-alt"></i>
					</div>
					<span class="btn btn-sm btn-light">Add to campaign</span>
				</div>
				<div
					class="text-center px-25 cursor-pointer" 
					@click="buildCheckinModal(new_physician.id, new_physician.display_name)"
					data-toggle="modal" data-target="#myModal" data-test="addNewPhysicianCheckin">
					<div class="rounded-circle circle-cropped avatar-md text-white text-center text-xl bg-secondary mx-auto my-2">
						<i class="fad fa-check-circle"></i>
					</div>
					<span class="btn btn-sm btn-light">Create check-in</span>
				</div>
			</div>

			<add-to-route 
				v-if="show_add_to_route"
				:location_id="new_physician.location_primary.id"
				@route_visit_added="displayAddToRoute(false)" />
			
			<add-to-campaign
				v-if="show_add_to_campaign"
				:physician_id="new_physician.id"
				@campaign_visit_added="displayAddToCampaign(false)" />

		</div>
		<div class="border-top text-right">
			<div class="d-flex pt-3 pb-3 px-3 justify-content-between">
				<span class="btn btn-ghost-secondary" @click="resetForm()"><i class="fal fa-long-arrow-left"></i> Add another</span>
				<span class="btn btn-primary" @click="closeModal()" data-test="closePhysicianModal">Close</span>
			</div>			
		</div>
	</template>

</div>
</div>
</div>
</template>

<script>
	import { mapState } from 'vuex';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';
	import { objectToFormData } from 'object-to-formdata';
	import { gmapApi } from 'vue2-google-maps';
	import AvatarField from './AvatarField';
	import AddToCampaign from './AddToCampaign';
	import AddToRoute from './AddToRoute';

	export default{

        components: {
            HasError,
            AlertError,
            AlertErrors,
            AlertSuccess,
            Form,
            AvatarField,
            AddToCampaign,
            AddToRoute,
        },

	    data() {
	        return {
	        	google_result: null,
	        	form_step: 1,
	        	form_step_completed: 0,
	        	submitting: false,
				form: new Form(),
				new_physician: null,

				checkin_options: {
					physician: null,
				},
				show_add_to_route: false,
				show_add_to_campaign: false,
	        }
	    },

	    mounted() {
	    	this.resetForm();

	    	let self = this;
			window.goToPhysician = function(physician_id) {
				self.$router.push({ name: 'physicians.show', params: { id: physician_id } });
			};
	    },

	    methods: {
	    	processLocationChanged($event) {
	    		this.google_result = $event;
	    	},

			buildCheckinModal(physician_id, display_name) {
				this.checkin_options.checkinables = {
					display_name : display_name,
					morphable_id : physician_id,
					morphable_type : 'App\\Physician',
				};
				this.$root.$emit('build_checkin_modal', { checkin_options: this.checkin_options });
				
				jQuery('#physicianCreateModal').modal('hide');
			},

	    	useGoogleResult() {
	    		this.setFormStep(2);

	    		const name = this.google_result.name.split(' ');

	    		//set prefixes first, then drop from array
	    		if (['dr,', 'dr.', 'mr.', 'mrs.', 'ms.'].includes(name[0].toLowerCase())) {
	    			this.form.prefix = name[0];
	    			name.shift();
	    		}

				//set suffixes next, then drop from array
	    		if (['md', 'do', 'rn', 'dr', 'dr.', 'rd', 'phd'].includes(name[name.length - 1].toLowerCase())) {
	    			this.form.suffix = name[name.length - 1];
	    			name.length = name.length - 1;
	    		}

	    		//remove any punctuation and drop 1-letter strings
	    		const preppedName = [];
	    		name.forEach((string) => {
	    			const preppedString = string.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
	    			if (preppedString.length > 1) {
	    				preppedName.push(preppedString);
	    			}
	    		});

	    		this.form.first_name = preppedName[0];
	    		preppedName.shift();
	    		this.form.last_name = preppedName.join(' ');

	    		//now do all the location fields
	    		let street_number = this.google_result.address_components.find((component) => {
	    			return component.types.find((type) => {
	    				return type.includes('street_number');
	    			});
	    		});

	    		let street = this.google_result.address_components.find((component) => {
	    			return component.types.find((type) => {
	    				return type.includes('route');
	    			});
	    		});

	    		let address_2 = this.google_result.address_components.find((component) => {
	    			return component.types.find((type) => {
	    				return type.includes('subpremise');
	    			});
	    		});

	    		let city = this.google_result.address_components.find((component) => {
	    			return component.types.find((type) => {
	    				return type.includes('locality');
	    			});
	    		});

	    		let state = this.google_result.address_components.find((component) => {
	    			return component.types.find((type) => {
	    				return type.includes('administrative_area_level_1');
	    			});
	    		});

	    		let zip = this.google_result.address_components.find((component) => {
	    			return component.types.find((type) => {
	    				return type.includes('postal_code');
	    			});
	    		});

	    		//account for possible missing values
	    		this.form.address = street_number ? street_number.long_name + ' ' + street.short_name : null;
	    		this.form.address_2 = address_2 ? address_2.long_name : null;
	    		this.form.city = city ? city.long_name : null;
	    		this.form.state = state ? state.short_name : null;
	    		this.form.zip = zip ? zip.short_name : null;
	    		this.form.phone = this.google_result.formatted_phone_number ? this.google_result.formatted_phone_number : null;

	    	},

            changedAvatar($event) {
                this.form.image = this.$refs.image_field.file;
            },

            closeModal() {
            	this.resetForm();
               	jQuery('.modal').modal('hide');
    			jQuery('.modal-backdrop').remove();
            },

	    	createPhysician() {
	    		this.submitting = true;

                this.form.submit('post', '/api/physicians', {
					transformRequest: [function (data, headers) {
						return objectToFormData(data)
					}],
                }).then(({ data }) => {
    				this.submitting = false;
    				this.new_physician = data;

					Swal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 4000,
                        icon: 'success',
                        title: 'Physician saved',
                        html: '<div><a href="#" onclick="goToPhysician(' + data.id + ')">View Physician</div>',
                    });

					this.$store.dispatch('addNewPhysician', data);
    			}).catch(() => {
    				this.submitting = false;
    			})
	    	},

	    	resetForm() {
	    		this.setFormStep(1);
	    		this.new_physician = null;
		    	this.form = new Form({
		    		prefix: 		null,
	                first_name:     null,
	                last_name:      null,
	                suffix: 		null,
	                npi:            null,
	                emails:          [],
	                specialty:    null,
	                status:         1,
	                client_id:      this.user.client_id,
	                image:          null,

	                label: 			null, 
	                address: 		null,
	                address_2: 		null,
	                city: 			null,
	                state: 			null,
	                zip: 			null,
	                phone: 			null,
	                fax: 			null,
	                source: 		null,
				});
				// add 1 email to start if it's empty
				if (this.form.emails.length == 0) {
				    this.addEmail();
				}
	    	},

	    	addEmail() {
	    	    this.form.emails.push({email: ''});
	    	},


	    	deleteEmail(emailString) {
	    	    for (var i=0; i < this.form.emails.length; i++) {
	    	        if (this.form.emails[i].email == emailString) {
	    	            this.form.emails.splice(i, 1); // delete
	    	        }
	    	    }
	    	},   

	    	setFormStep(step) {
	    		this.form_step = step;
	    		if (step >= this.form_step_completed) {
	    			this.form_step_completed = step;
	    		}
	    	},

	    	setSource(source) {
	    		if (!source) {
	    			this.form.source = null;
	    		}

	    		if (source == 'google') {
	    			this.form.source = 'google';
	    		}
	    		if (source == 'manual') {
	    			this.setFormStep(2);
	    		}
	    	},

	    	displayAddToCampaign(value) {
	    		this.show_add_to_campaign = value;
	    		this.show_add_to_route = false;
	    	},

	    	displayAddToRoute(value) {
	    		this.show_add_to_route = value;
	    		this.show_add_to_campaign = false;
	    	},

		    submitForm() {
			    this.createPhysician();
		    },	    	
	    },

	    computed: mapState(['options', 'user']),

	}
</script>

<style>
	#physicianCreateModal .faded {
		opacity: .5;
	}

	#physicianCreateModal .avatar-custom { 
		width:18px;
		height:18px;
		line-height:20px;
	}

	#physicianCreateModal .button-wrap {
		margin:0 -1rem; 
	}

	.select-state .vs__search { 
		padding:0 !important;
	}
</style>